import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('[ErrorBoundary] Erro capturado:', error, info);
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/home';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 text-white px-4">
          <h1 className="text-4xl font-bold text-red-400 mb-4">Algo deu errado</h1>
          <p className="text-gray-400 mb-8 text-center">
            Ocorreu um erro inesperado. Tente voltar ao início.
          </p>
          <button
            onClick={this.handleReset}
            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 rounded-lg font-medium transition-colors"
          >
            Voltar ao início
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
